import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Link } from 'react-router-dom';

const Navbar = () => {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user'));
    const lang = false;
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const logout = () => {
        // Rimuoviamo il token e l'utente per terminare completamente la sessione
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Navighiamo al login e ricarichiamo per pulire lo stato React
        window.location.href = '/login';
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        if (dropdownOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [dropdownOpen]);

    return (
        <nav className="navbar">
            <Link to="/" className="logo">
                <img src="/img/logo.png" alt="La Partitella" className="nav-logo-img" />
            </Link>
            <div className="nav-links">
                {lang ? (<button className="lang-toggle" onClick={() => i18n.changeLanguage(i18n.language === 'it' ? 'en' : 'it')}>
                    🌐 {i18n.language.toUpperCase()}
                </button>) : null}
                {user ? (
                    <div className="user-dropdown-container" ref={dropdownRef}>
                        <button
                            className="user-menu-trigger"
                            onClick={() => setDropdownOpen(!dropdownOpen)}
                        >
                            <span className="welcome-text"><span>{t('welcome')},</span> <strong>{user.name}</strong></span>
                            <span className="dropdown-arrow">▼</span>
                        </button>

                        {dropdownOpen && (
                            <div className="user-dropdown-menu" onClick={() => setDropdownOpen(false)}>
                                <Link to="/my-matches">🗓️ {t('my_matches').toUpperCase()}</Link>
                                <Link to="/profile">👤 {t('your_profile').toUpperCase()}</Link>
                                <button onClick={logout} className="dropdown-logout-btn">🚪 {t('logout').toUpperCase()}</button>
                            </div>
                        )}
                    </div>
                ) : (
                    <Link to="/login" className="login-link">{t('login')}</Link>
                )}
            </div>
        </nav>
    );
};

export default Navbar;
